import cn from 'classnames';
import { Element, Icon } from 'src/components';
import { AuthUtils, Logger } from 'src/utils';
import useAuth from 'src/hooks/useAuth';
import CookieStore from 'src/utils/cookie';
import { COOKIE_KEY } from 'src/constants';

interface IProps {
    className?: string;
    textButton?: string;
    cb?: (e?: any) => void;
}

const ZaloLoginButton = ({
    className = '',
    textButton = 'Zalo',
    cb,
}: IProps) => {
    const { auth } = useAuth();
    const _cb = (e: any) => {
        auth();
        if (cb) {
            cb(e);
        }
    };

    const handleLogin = () => {
        Logger.debug('on login');
        (window as any).ZA?.handleCookieConsentGranted();
        CookieStore.set(COOKIE_KEY.BM_CLICK_LOGIN, true);
        setTimeout(() => {
            AuthUtils.login(_cb);
        }, 100);
    };
    return (
        <Element
            className={cn(
                'btn-zalo',
                'flex items-center',
                'h-[44px]',
                'p-[6px_8px]',
                'rounded-[4px]',
                'cursor-pointer',
                'bg-[#03a5fa]',
                'hover:bg-[#0284c8]',
                className
            )}
            onClick={handleLogin}
        >
            <Icon type="bm" icon="zalo"></Icon>
            <span
                className={cn(
                    'relative',
                    'text-[18px] text-white font-[900]',
                    'mb-0 ml-[12px] pl-[12px]',
                    'before:absolute before:left-0 before:top-[4px]',
                    'before:w-[1px] before:h-[20px] before:bg-[rgba(255,255,255,0.4)]'
                )}
            >
                {textButton}
            </span>
        </Element>
    );
};

export default ZaloLoginButton;
